import { useToast } from '@chakra-ui/react';

import TrialUpgradeLink from '../../trialUser/TrialUpgradeLink';

export function useTrialUserBlurToast() {
  const toast = useToast();
  return () => {
    if (toast.isActive('td-trial-toast')) return;
    toast({
      id: 'td-trial-toast',
      title: 'Upgrade Required',
      description: (
        <span>
          Masked data is not available to trial users.{' '}
          <TrialUpgradeLink
            toastIdClose="td-trial-toast"
            linkText="Upgrade your trial"
          />{' '}
          to view.
        </span>
      ),
      status: 'warning',
      duration: null,
      isClosable: true,
      position: 'top-right',
      variant: 'subtle',
    });
  };
}
